const styles = theme => ({
    grow: {
      flexGrow: 1
    },
    toolbar: {
      borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
      paddingLeft: '24px',
      paddingRight: '24px'
    },
    sidebarCard: {
      width: '280px',
      minWidth: '280px',
      height: 'fit-content',
      margin: '20px',
      borderRadius: '8px',
      border: '1px solid #E0E0E0',
      overflow: 'hidden'
    },
    sidebarHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 20px',
      borderBottom: '1px solid #F0F0F0'
    },
    categoryItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 20px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      borderLeft: '4px solid transparent',
      "&:hover": {
        backgroundColor: '#F5F5F5',
        "& .action-icons": {
          opacity: 1
        }
      }
    },
    activeCategory: {
      backgroundColor: '#EDF4FB !important',
      borderLeft: '4px solid #2196F3',
      "& .category-name": {
        color: '#2196F3',
        fontWeight: 600
      }
    },
    categoryName: {
      fontSize: '14px',
      color: '#333'
    },
    categorySubtext: {
      fontSize: '12px',
      color: '#999'
    },
    actionIcons: {
      display: 'flex',
      gap: '8px',
      opacity: 0,
      transition: 'opacity 0.2s ease'
    },
    addIntentButton: {
      color: '#2196F3',
      fontWeight: 'bold',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '14px'
    }
  })
  
  export default styles
  